// adjust the <table> & apply special styling based on inline styles
// .ck-table-resize gets added to the tables that were manually resized
const tables = document.querySelectorAll('.paragraph-text table');

const addWrapper = (table) => {
  // adds wrapper around the table bc we need
  // scroll on mobile screens
  const wrapper = document.createElement('div');
  wrapper.classList.add('table-wrapper');
  table.parentNode.insertBefore(wrapper, table);
  wrapper.appendChild(table);
};

const addHighlightedColumn = (table) => {
  // custom background color goes to th or td
  const tableDataCells = table.querySelectorAll('tr > *');
  tableDataCells.forEach((cell) => {
    // remove inline width values
    cell.style.width = '';
    // change the color of the text color,
    if (cell.style.backgroundColor !== '') {
      cell.style.setProperty('--table-cell-color', '#fff');
    } else {
      // remove any other background if added by editors
      cell.style.backgroundColor = '';
    }
  });
};

// round %s coming from ckEditor
const calculateColumWidth = (table) => {
  const cols = table.querySelectorAll('colgroup col');
  cols.forEach((c) => {
    // round to the closest 10
    const width = Math.round(parseInt(c.style.width) / 10) * 10;
    c.style.width = `${width}%`;
  });
};

(() => {
  if (tables.length) {
    tables.forEach((t) => {
      addHighlightedColumn(t);
      addWrapper(t);

      if (t.classList.contains('ck-table-resized')) {
        calculateColumWidth(t);
      }
    });
  }
})();
